import React from 'react';
import t from '~t';
import { useSelector } from 'react-redux';
import { getDraftError } from '~data/selectors/bookmarks';

import { Layout, ButtonRow, Button, Alert } from '~ui';

export default function EditBookmarkCrash({ _id, onLoad }) {
  const error = useSelector((state) => getDraftError(state, _id));

  return (
    <Layout data-stretch>
      <Alert variant='danger'>
        {error.error && t.has('server' + error.error)
          ? t.s('server' + error.error)
          : error.message}
      </Alert>

      <ButtonRow>
        <Button onClick={onLoad}>{t.s('tryAgain')}</Button>
      </ButtonRow>
    </Layout>
  );
}
